export default "__VITE_ASSET__cNh2yDt8__"